<footer class="flex flex-col gap-1">
    <p-splitter />
    @if (iconOnly()) {
        <ng-container [ngTemplateOutlet]="iconContent().templateRef" />
    } @else {
        <ng-container [ngTemplateOutlet]="expandedContent().templateRef" />
    }
</footer>
